<template>
  <router-link :to="{ name: 'users.edit', params: { id: user.id } }">
    <i v-if="user.company_id" class="icon-office"></i>
    {{ user.name }}
  </router-link>
</template>

<script>
export default {
  name: 'UserLink',

  props: {
    user: {
      type: Object,
      required: true,
    },
  },
}
</script>
